export function itemRenderer(item?: { id: number; code?: string; name?: string; description?: string }) {
  if (!item) {
    return undefined;
  }

  return (
    <>
      <strong>{item.code}</strong> - {item.name || item.description}
    </>
  );
}

export function binItemRenderer(item?: { id: number; code?: string; warehouseCode?: string; name?: string }) {
  if (!item) {
    return undefined;
  }

  return (
    <>
      <strong>{item.code}</strong>
    </>
  );
}

export function userItemrenderer(item?: { id: number; username?: string }) {
  if (!item) {
    return undefined;
  }

  return (
    <>
      <strong>{item.username}</strong>
    </>
  );
}

export function recipientItemRenderer(item?: { name?: string; email?: string }) {
  if (!item) {
    return undefined;
  }

  return (
    <>
      <strong>{item.email}</strong> - {item.name}
    </>
  );
}
